import { useContext } from 'react';
import { UserContext } from 'routes/login/userContext';

export default function useIsAdminUser() {
  const user = useContext(UserContext);
  const isAdminUser = user.role?.name === 'admin';
  return isAdminUser;
}
